import React, { useEffect } from 'react';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4maps from '@amcharts/amcharts4/maps';
import am4geodata_worldLow from '@amcharts/amcharts4-geodata/worldMoroccoLow';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import { countries } from '../../global/countriesAndSources';

const Map = (props) => {
  const setSelectedCountry = props.setSelectedCountry;
  const mapDisplay = props.displayMap;
  const setDisplayMap = props.setDisplayMap;

  useEffect(() => {
    const el = document.getElementById('globeDiv');
    if (el) el.style.display = mapDisplay ? '' : 'none';

    am4core.useTheme(am4themes_animated);

    const chart = am4core.create('globeDiv', am4maps.MapChart);
    chart.geodata = am4geodata_worldLow; // base monde
    chart.projection = new am4maps.projections.Orthographic();
    chart.panBehavior = 'rotateLongLat';
    chart.deltaLatitude = -20;
    chart.padding(20, 20, 20, 20);

    // --- Couche pays
    const polygonSeries = chart.series.push(new am4maps.MapPolygonSeries());
    polygonSeries.useGeodata = true;

    const polygonTemplate = polygonSeries.mapPolygons.template;
    polygonTemplate.tooltipText = '{name}';
    polygonTemplate.fill = am4core.color('#008eb5');
    polygonTemplate.stroke = am4core.color('#cae1e1');
    polygonTemplate.strokeWidth = 0.75;

    polygonTemplate.events.on('hit', (ev) => {
      setDisplayMap(false);
      const countryId = (ev.target.dataItem.dataContext.id || '').toLowerCase();
      const country = countries.find((c) => c.code === countryId);
      if (country) {
        setSelectedCountry(country);
        const li = Array.from(document.getElementsByClassName('divli'))
          .find((c) => c.innerText === country.name);
        li && li.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });

    const hs = polygonTemplate.states.create('hover');
    hs.properties.fill = am4core.color('#9cfdff');

    // --- Rotation auto
    const anim = chart.animate({ property: 'deltaLongitude', to: 10000 }, 1000000, am4core.ease.linear);
    anim.events.on('animationended', () => anim.restart());
    chart.seriesContainer.events.on('down', () => anim.stop());

    chart.hidden = !mapDisplay;

    // =========================
    //  LIGNES DE FRONTIÈRES EN POINTILLÉ
    // =========================
    const dashedSeries = chart.series.push(new am4maps.MapLineSeries());
    dashedSeries.zIndex = 1000; // au-dessus
    dashedSeries.dataFields.multiGeoLine = 'multiGeoLine';

    // Style par défaut des lignes pointillées
    const lt = dashedSeries.mapLines.template;
    lt.stroke = am4core.color('#000');
    lt.strokeWidth = 2.4;
    lt.strokeOpacity = 1;
    lt.strokeDasharray = '1'; // motif pointillé
    lt.nonScalingStroke = true; // garde une épaisseur lisible au zoom
    lt.tooltipText = '{label}';

    // 2) Crimée : isthme de Perekop
    //    Longitudes d’ouest en est (ligne quasi droite)
    //    Faire des segments
    const crimeaSeg1 = [
      { longitude: 33.659, latitude: 45.93 },
      { longitude: 33.969, latitude: 45.99 },
      { longitude: 34.492, latitude: 46.117 },
      { longitude: 34.855, latitude: 46.197 }
    ];

    dashedSeries.data = [
      { label: 'Crimée (isthme de Perekop)', multiGeoLine: [ crimeaSeg1 ] },
    ];

    const roundedSeries = chart.series.push(new am4maps.MapLineSeries());
    roundedSeries.zIndex = 1000; // au-dessus
    roundedSeries.dataFields.multiGeoLine = 'multiGeoLine';

    const rt = roundedSeries.mapLines.template;
    rt.stroke = am4core.color('#000');
    rt.strokeWidth = 2.4;
    rt.strokeOpacity = 1;
    rt.nonScalingStroke = true;

       // Données : segments approximatifs (à affiner si besoin)
    // 1) Maroc ↔ Sahara occidental : proche du parallèle ~27.6667°N
    //    Créer une bordure cercle pour représenter le sahara occidental (faire un cercle ou le centre est 24.678286, -13.766058)
    const wsBorder = [];
    const centerLat = 24.678286;
    const centerLon = -13.766058;
    const radius = 1.0;
    for (let angle = 0; angle <= 360; angle += 10) {
      const rad = (angle * Math.PI) / 180;
      const latitude = centerLat + radius * Math.sin(rad);
      const longitude = centerLon + radius * Math.cos(rad);
      wsBorder.push({ latitude, longitude });
    }

    roundedSeries.data = [
      { label: 'Sahara occidental', multiGeoLine: [ wsBorder ] },
    ];

    return () => {
      chart.dispose();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mapDisplay]);

  const queryCountry = new URLSearchParams(window.location.search).get('country');
  if (queryCountry === null || queryCountry === undefined) {
    return <div id="globeDiv" style={{ width: '100%', height: '60vh' }} />;
  }
};

export default Map;
